import axios from "axios";
import { IP } from "../index.js";

/**
 * 生成门店二维码
 * @param {*} data
 * @returns
 */
export async function createCode(data) {
  var resp = await axios.post(`${IP}/getCode/create`, data);
  return resp.data;
}
